import _omit from 'lodash/omit';
import { $can } from './auth';
import { isSettingEnabled } from './initiatives';

const checkPermission = (navItem, adminMode, permissions) =>
  $can(
    {
      adminMode: navItem.adminMode,
      permission: navItem.permission,
      initiativeMode: navItem.initiativeMode,
    },
    permissions,
    adminMode,
  );

export const filterNavByPermissions = (nav, adminMode, permissions, userInitiativeRole) => {
  const filtredNav = [];

  nav.forEach((navItem) => {
    if (checkPermission(navItem, adminMode, permissions)) {
      // disable navigation item if user has forbidden initiative role
      if (navItem.forbiddenInitiativeRoles?.includes(userInitiativeRole)) {
        return;
      }

      // if navigation item has children, filter them by permissions and initiative settings
      if (navItem._children) {
        filtredNav.push({
          ...navItem,
          _children: navItem._children
            .filter((child) => checkPermission(child, adminMode, permissions))
            .map((child) => _omit(child, ['adminMode', 'initiativeMode', 'initiativeSettingKey'])),
        });
        return;
      }

      filtredNav.push(navItem);
    }
  });

  return filtredNav;
};

export const filterNavByInitiativeSettings = (nav, initiativeSettings) =>
  nav.filter((navItem) => isSettingEnabled(navItem.initiativeSettingKey, initiativeSettings));
